export default "__VITE_ASSET__C_t0T7XZ__"